import React, { useMemo } from "react";
import { BaseIO } from "../../GlobalModals/editSectionModal";
import { TerminalInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";
import { useTranslation } from "react-i18next";
import { DeviceInfo } from "../../../Services";
import { LocationInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";

export interface TerminalDataProps {
  locationName: {
    text: string;
    value: string;
  };
  terminals: BaseIO[];
  visual: string | undefined;
  location_id: number;
}

export const terminalsData = ({ terminals, devices, t }: { terminals: TerminalInfo[], devices: DeviceInfo[], t: Function }): BaseIO[] => { 
  return terminals.flatMap(terminal => {
    const programmedArr = terminal.programmed?.toString(2).split("").reverse();

    let boardDisabled = false;
    let offset = 0;
    let text = `${offset === 1 ? t("motorSpecs.terminalTypes.input", {defaultValue: "Input"}) : t("motorSpecs.terminalTypes.output", {defaultValue: "Output"})}`;
  
    if (terminal.fk_terminal_types === 5 && terminal.next === null) {
      text = t("motorSpecs.terminalTypes.buttonInput", { defaultValue: "Button Input" });
      offset = 1;
    } else if (terminal.fk_terminal_types === 5 && terminal.next !== null) {
      text = t("motorSpecs.terminalTypes.gateSensorInput", { defaultValue: "Gate Sensor Input" });
      offset = 1;
    } else if (terminal.fk_terminal_types === 5 && terminal.next === undefined) {
      text = t("motorSpecs.terminalTypes.digitalInput", { defaultValue: "Digital Input" });
      offset = 1;
    } else if (terminal.fk_terminal_types === 53) {
      text = t("motorSpecs.terminalTypes.waterOutput", { defaultValue: "Water Output" });
    } else if (terminal.fk_terminal_types === 54) {
      text = t("motorSpecs.terminalTypes.inputMotor", { defaultValue: "Input Motor" });
      offset = 1;
    } else if (terminal.fk_terminal_types === 80 || terminal.fk_terminal_types === 81) {
      text = "Feeder Output";
    } else if (terminal.fk_terminal_types === 82) {
      text = "Activator Input";
      offset = 1;
    } else if (terminal.fk_terminal_types === 83) {
      text = t("motorSpecs.terminalTypes.cupMotorOutput", { defaultValue: "Cup Motor Output" });
    } else if (terminal.fk_terminal_types === 84) {
      text = t("motorSpecs.terminalTypes.gateMotorOutput", { defaultValue: "Gate Motor Output" });
    } else if (terminal.fk_terminal_types === 200) {
      text = t("motorSpecs.terminalTypes.rfidReader", { defaultValue: "RFID Reader" });
      offset = 2;
    }

    const baseRow: BaseIO = {
      offset,
      terminal_id: terminal.terminal_id,
      text,
      port: terminal.port ?? "",
      board: devices?.find(d => d.device_id === terminal.fk_devices),
      programmedDisabled: !!(programmedArr && programmedArr.length >= 1 && programmedArr[0] === "1"),
      programmed: terminal.programmed ?? 0,
      boardDisabled,
      components: terminal.fk_components ?? undefined,
      calibrationVal: terminal.val2_min
    };

    if (terminal.sensor_p !== null && terminal.sensor_p !== undefined) {
      const sensorRow: BaseIO = {
        ...baseRow,
        offset: 1,
        text: terminal.fk_terminal_types === 83 ? t("motorSpecs.terminalTypes.cupMotorInput", {defaultValue: "Cup Motor Input"}) : terminal.fk_terminal_types === 84 ? t("motorSpecs.terminalTypes.gateMotorInput", {defaultValue:"Gate Motor Input"}) : t("motorSpecs.terminalTypes.sensorP", {defaultValue: "SensorP"}),
        port: terminal.port ?? "",
        boardDisabled: terminal.fk_terminal_types === 83 || terminal.fk_terminal_types === 84,
        components: undefined,
        sensor_p: terminal.sensor_p
      };
      return [baseRow, sensorRow];
    }

    return [baseRow];
  });
  }
